"use client";

import { useState, useMemo } from "react";
import Image from "next/image";
import { NewButton } from "@/components/ui/NewButton";
import { env } from "@/lib/environment";

export default function VideoPreview() {
  const [isPlaying, setIsPlaying] = useState(false);

  const iframeSrc = useMemo(() => {
    const base = "https://www.youtube.com/embed/QdIF6qp7uFc";
    return isPlaying ? `${base}?autoplay=1&mute=1&rel=0` : base;
  }, [isPlaying]);

  return (
    <div className="flex my-12 relative">
      {!isPlaying && (
        <Image
          src={`${env.NEXT_PUBLIC_CDN_URL}/images/home/thumbmail-youtube.G4jXoQSXPYNb.webp`}
          alt="video thumbnail"
          title="video thumbnail"
          width={956}
          height={552}
          sizes="(max-width: 956px) calc(100vw - 48px), 956px"
          loading="lazy"
          decoding="async"
          className="w-full max-w-[956px] border-4 border-black mx-auto aspect-video"
        />
      )}

      {isPlaying && (
        <iframe
          src={iframeSrc}
          title="Pickcel in a Minute"
          width={956}
          height={552}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          className="w-full max-w-[956px] mx-auto h-auto aspect-video"
        />
      )}

      {!isPlaying && (
        <div className="absolute inset-0 inset-y-0 flex items-center justify-center">
          <NewButton
            variant="outlinePrimary"
            size="lg"
            className="border-0 p-0 h-auto border-none rounded-none bg-transparent hover:shadow-none outline-none"
            onClick={() => setIsPlaying(true)}
          >
            <Image
                src={env.NEXT_PUBLIC_CDN_URL + "/images/home/youtube-play.svTXmtXsmp0p.webp"}
                alt="play button"
                width={150}
                height={105}
                title="play button"
                className="w-10 md:w-[150px] "
              />
            {/* Pickcel in a Minute
            <span className="relative group">
              <Image
                src={env.NEXT_PUBLIC_CDN_URL + "/images/shared/ply.v4KomfWuxQXs.svg"}
                alt="play button"
                width={20}
                height={20}
                title="play button"
                className="group-hover:opacity-0 w-4 h-4 md:w-5 md:h-5 transition-opacity duration-200"
              />
              <Image
                src={env.NEXT_PUBLIC_CDN_URL + "/images/shared/play-active.LytI4zY-VVHn.svg"}
                alt="play button"
                width={20}
                height={20}
                title="play button"
                className="absolute top-0 rounded-full left-0 opacity-0 w-4 h-4 md:w-5 md:h-5 group-hover:opacity-100 group-hover:bg-[#BFC2D2] transition-opacity duration-200"
              />
            </span> */}
          </NewButton>
        </div>
      )}
    </div>
  );
}


